import React from "react";
import { FxRatesPanel } from "./FxRatesPanel.jsx";

export function CurrencyRatesPage() {
  return (
    <div style={{ maxWidth: "1400px", padding: "24px 32px 40px", margin: "0 auto", width: "100%" }}>
      <FxRatesPanel currentRole="viewer" />
    </div>
  );
}
